<template>
  <div class="box">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :show-close="false"
      :close-on-press-escape="false"
      custom-class="drawer-class"
      :size="size"
    >
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
        众筹救助申请信息
        <div style="float:right;">
          <i class="el-icon-question"></i>如何填写？
          <a
            href="javascript:;"
            style="color:#b60205;text-decoration:underline"
            @click="helpMe"
          >查看示意图</a>
        </div>
      </div>

      <el-dialog :visible.sync="help_show" width="80%" append-to-body title="众筹项目救助申请示意图">
        <img width="100%" src="../../../../assets/images/cfpro_apply_help1.png" alt />
      </el-dialog>

      <el-form
        :model="applyForm"
        :rules="rules"
        ref="applyRef"
        label-width="120px"
        label-position="top"
        style="margin-bottom:80px;margin:0 50px 80px;"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="众筹项目"
              prop="project_id"
              v-if="this.$route.query.id && applyForm.project_name"
            >
              <el-input v-model="applyForm.project_name" disabled></el-input>
            </el-form-item>
            <el-form-item label="众筹项目" prop="project_id" v-else>
              <el-select
                v-model="applyForm.project_apply_id"
                placeholder="请选择一个项目"
                @change="selProject"
                style="width:65%"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.project_apply_id"
                  :label="item.project_name"
                  :value="item.project_apply_id"
                >
                  <span style="float: left">
                    {{ item.project_name }}（
                    <span style="color:red">{{item.balance}}</span> 元）
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.apply_time }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="姓名" prop="user_name">
              <el-input v-model="applyForm.user_name" style="width:65%" :maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="font-size: 14px;color: #606266;">
            免冠照片
            <div style="margin-left:45px">
              <el-upload
                class="avatar-uploader"
                :action="uploadImgUrl"
                name="img"
                :data="uploadParms"
                :on-success="onSuccess"
                :before-upload="beforeUpload"
                :show-file-list="false"
              >
                <img
                  :src="uploadImgHeadPic"
                  v-if="showHeadPic"
                  title="点击更换照片~"
                  style="margin-left:45px;width: 178px; height: 178px"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  title="点击上传照片~"
                  style="margin-left:45px;border:1px dashed #ccc"
                ></i>
                <br />
              </el-upload>
              <span style="margin-left:45px">
                <i class="el-icon-info"></i> 只能上传jpg/png文件，且不超过50M
              </span>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="user_cardno">
              <el-input v-model.trim="applyForm.user_cardno" style="width:65%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请人类别" prop="apply_type" style="width:100%">
              <el-select
                multiple
                v-model="applyForm.apply_type"
                placeholder="请先选择众筹项目"
                @change="selApplyType"
                style="width:65%"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(item,index) in userTypeList"
                  :key="index"
                  :label="item.apply_user_type_text"
                  :value="item.apply_user_type"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="联系手机" prop="phone">
              <el-input v-model="applyForm.phone" style="width:65%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="籍贯" prop="jg">
              <el-input v-model="applyForm.jg" style="width:65%" :maxlength="10"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="出生日期" prop="birthday">
              <el-date-picker
                type="date"
                style="width:65%"
                value-format="yyyy-MM-dd"
                placeholder="选择出生日期"
                v-model="applyForm.birthday"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入院日期" prop="admission_time">
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width:65%"
                v-model="applyForm.admission_time"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="家庭总收入/年" prop="family_year_income">
              <el-input v-model="applyForm.family_year_income" style="width:65%" :maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医保报销类型" prop="ybbxlx">
              <el-select
                v-model="applyForm.ybbxlx"
                placehoder="请选择医保报销类型"
                :popper-append-to-body="false"
                style="width:65%"
              >
                <el-option
                  v-for="(item,index) in ybTypeList"
                  :key="index"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="项目负责人" prop="leader">
              <el-input v-model="applyForm.leader" style="width:65%" :maxlength="15"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="负责人电话" prop="leader_tel">
              <el-input v-model="applyForm.leader_tel" style="width:65%" :maxlength="15"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="otherMoney.top_money">
          <el-col>
            <el-form-item label="费用提醒：">
              项目分配金额：
              <span style="color:red">{{otherMoney.top_money}}</span>元；
              已拨款金额：
              <span style="color:red">{{otherMoney.settled_money}}</span>元；
              未拨款金额：
              <span style="color:red">{{otherMoney.unsettled_money}}</span>元；
              预扣款金额：
              <span style="color:red">{{otherMoney.balance}}</span>元；
              申请结余：
              <span style="color:red">{{otherMoney.apply_balance}}</span>元
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="eyeEditInfo.length > 0">
          <el-col>
            <el-form-item label="眼疾信息">
              <p v-for="(item,index) in eyeEditInfo" :key="index">
                {{item.text}}：
                <span style="color:red">{{item.eye_money}}</span>元
              </p>
              <p>
                如需更改，请执行
                <span
                  style="text-decoration: underline;margin:0 5px; color:red; cursor: pointer;"
                  @click="clearEye"
                >清空</span>操作
              </p>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-else>
          <el-col>
            <el-form-item label="眼疾信息" required>
              <el-table
                :data="eyesData"
                border
                style="width: 800px"
                show-summary
                :summary-method="getSummaries"
              >
                <el-table-column label="申请人类别" width="250">
                  <template slot-scope="scope">
                    <div slot="reference" class="name-wrapper">
                      <el-select
                        v-model="eyesData[scope.$index].user_type"
                        placeholder="请先选择申请人类别"
                        value-key="a_index"
                        @change="selUserType($event,scope.$index)"
                        :popper-append-to-body="true"
                      >
                        <el-option
                          :label="item.apply_user_type_text"
                          :value="item.apply_user_type"
                          v-for="(item,index) in eyeTypeList"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="类型" width="250">
                  <template slot-scope="scope">
                    <div slot="reference" class="name-wrapper">
                      <el-select
                        v-model="eyesData[scope.$index].eye_type"
                        @change="selEyeType($event,scope.$index)"
                        placeholder="请先选择眼疾类别"
                        filterable
                        value-key="a_index"
                        :popper-append-to-body="true"
                      >
                        <el-option
                          :label="item.eye_diseases_text+'('+item.eys_esparation_text+')'"
                          :value="item"
                          v-for="(item,index) in moneyList[scope.$index]"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="申请金额" width="200">
                  <template slot-scope="scope">
                    <div slot="reference" class="name-wrapper">
                      <el-input-number
                        v-model="eyesData[scope.$index].eye_money"
                        placeholder="请输入申请金额"
                        :disabled="JSON.stringify(eyesData[scope.$index].eye_type) == '{}'?true:false"
                        controls-position="right"
                        :max="999999999"
                        @change="showMessage($event,scope.$index)"
                      ></el-input-number>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="address" label="操作">
                  <template slot="header" slot-scope="scope">
                    <el-button
                      @click="addTableRow(scope.$index)"
                      type="primary"
                      icon="el-icon-plus"
                      size="mini"
                      circle
                    ></el-button>
                  </template>
                  <template slot-scope="scope">
                    <div slot="reference" class="name-wrapper">
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)"
                      >删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="现居住地址" prop="province_id" required>
              <el-select
                v-model="applyForm.province_id"
                placeholder="请选择省份"
                @change="getCity"
                style="width:265px"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in provinceLists"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="applyForm.city_id"
                placeholder="请选择城市"
                @change="getCounty"
                :clearable="true"
                style="width:265px"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in cityLists"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="applyForm.county_id"
                placeholder="请选择县/区"
                :clearable="true"
                style="width:265px"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in countyLists"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="详细地址" prop="home_address">
              <el-input
                type="textarea"
                :rows="3"
                :maxlength="100"
                placeholder="请输入现居住详细地址"
                v-model="applyForm.home_address"
                style="width:60%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="贫困证件" required>
              <el-upload
                ref="uploadRef"
                :action="uploadFileUrl"
                :file-list="defFiles"
                style="width:60%"
                :before-upload="beforeUploadFile"
                :on-success="(response, file, fileList) =>{
                  defFiles = fileList;
                }"
                :on-remove="(file, fileList) =>{
                  defFiles = fileList;
                }"
              >
                <el-button size="small" type="primary">点击上传文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="备注" prop="remarks">
              <el-input
                v-model="applyForm.remarks"
                type="textarea"
                :rows="3"
                :maxlength="200"
                style="width:60%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="demo-drawer-footer">
        <el-button @click="closeBtn" type="danger" size="small" icon="el-icon-close">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          :loading="loading"
          size="small"
          icon="el-icon-check"
        >立即申请</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: Object,
      default: () => {}
    },
    size: {
      type: [String, Number],
      default: "85%"
    },
    id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    var checkDistinct = (rule, value, callback) => {
      if (
        this.applyForm.city_id == null ||
        this.applyForm.city_id == "" ||
        typeof this.applyForm.city_id == "undefined" ||
        this.applyForm.county_id == null ||
        this.applyForm.county_id == "" ||
        typeof this.applyForm.county_id == "undefined"
      ) {
        return callback(new Error("请选择现居住地址"));
      }
      return callback();
    };
    var checkPhone = (rule, value, callback) => {
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(value)) {
        return callback(new Error("手机号码格式不正确！"));
      } else {
        return callback();
      }
    };
    var checkUserCardno = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请填写身份证号码！"));
      }

      var isValid = true;
      var cityCode = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 "
      };
      var rFormat = /^\d{6}(19|20)\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$|^\d{6}\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}$/; // 格式验证

      if (!rFormat.test(value) || !cityCode[value.substr(0, 2)]) {
        isValid = false;
      }
      // 18位身份证需要验证最后一位校验位
      else if (value.length === 18) {
        var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
        var Ci = "10X98765432"; // 校验字符
        // 加权求和
        var sum = 0;
        for (var i = 0; i < 17; i++) {
          sum += value.charAt(i) * Wi[i];
        }
        // 计算校验值
        var C17 = Ci.charAt(sum % 11);
        // 与校验位比对
        if (C17 !== value.charAt(17)) {
          isValid = false;
        }
      }

      if (!isValid) {
        return callback(new Error("请填写正确的身份证号码！"));
      } else {
        this.handleInfoReader();
        return callback();
      }
    };
    return {
      visible: false,
      loading: false,

      uploadFileUrl: "", //上传文件接口url
      uploadImgUrl: "", //上传图片接口url

      eyeTypeList: [], //用户选择的申请类别

      help_show: false,

      defFiles: [], //文件的初始值

      uploadParms: { file_type: 2 }, //图片上传所需参数
      userTypeList: [], //申请人类别

      ybTypeList: [], //医保类型

      projectList: [], //符合要求的众筹项目列表
      readmeFiles: [], //协议附件列表
      project_id: null, //选择项目是的项目id
      agreementDialog: false, //协议弹框
      ifDownAgFile: false, //判断是否下载协议

      eyeEditInfo: [], //
      curPage: 1, //当前页面
      moneyList: [], //获取资金使用标准
      otherMoney: {}, //获取该项目的其他金额
      applyExtendInfo: {}, //项目扩展信息

      dialogVisible: false,
      dialogImageUrl: "",
      curTrPicsName: null, //相关材料的当前行的存放图片集的变量

      uploadImgHeadPic: "",
      showHeadPic: false,

      provinceLists: [], //省集合
      cityLists: [], //市集合
      countyLists: [], //县集合

      eyesData: [],

      applyForm: {
        user_sex: 1,
        user_cardno: "",
        province_id: null,
        county_id: null,
        // cardno_pic: [],
        // household_pic: [],
        // pic: [],
        // files: [],
        city_id: null,
        apply_amount: null,
        age: null,
        apply_type: [],
        jg: null,
        // domicile: null,
        family_year_income: null,
        leader: null,
        leader_tel: null,
        poor_files: [],
        remarks: null
      },
      rules: {
        project_id: [
          { required: true, message: "请选择众筹项目", trigger: "change" }
        ],
        user_name: [
          { required: true, message: "请输入申请人姓名", trigger: "blur" }
        ],
        jg: [{ required: true, message: "请输入户籍贯", trigger: "blur" }],
        user_cardno: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: checkUserCardno, trigger: "change" }
        ],
        // age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        apply_type: [
          {
            required: true,
            type: "array",
            message: "请选择申请人类别",
            trigger: "change"
          }
        ],
        // apply_reason: [
        //   { required: true, message: "请填写申请理由", trigger: "blur" }
        // ],
        // admission_time: [
        //   { required: true, message: "请选择入院日期", trigger: "change" }
        // ],
        // ybbxlx: [
        //   { required: true, message: "请选择医保报销类型", trigger: "change" }
        // ],
        family_year_income: [
          { required: true, message: "请填写家庭年收入", trigger: "blur" }
        ],
        leader: [
          { required: true, message: "请填写项目负责人", trigger: "blur" }
        ],
        leader_tel: [
          { required: true, message: "请填写项目负责人电话", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],

        province_id: [
          { required: true, message: "请选择现居住地址", trigger: "change" },
          { validator: checkDistinct, trigger: "change" }
        ]
      }
    };
  },

  watch: {
    visible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    //示意图操作
    helpMe() {
      this.help_show = true;
    },

    beforeUploadFile(file) {
      let bool = this.$fnc.checkUploadFile(file);
      return bool;
    },

    //千分化金额
    setMoneyFormat(num) {
      if (num) {
        let value = typeof num === "number" ? num : Number(num);
        return (value.toFixed(2) + "").replace(
          /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
          "$&,"
        );
      }
    },

    //计算表格合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (index === 1 || index === 3) {
          return "";
        }

        const values = data.map(item => Number(item.eye_money));

        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      if (sums[2] > 0) {
        this.applyForm.apply_amount = sums[2];
        sums[2] = "总额：" + this.setMoneyFormat(sums[2]) + " 元";
      }

      return sums;
    },

    closeBtn() {
      this.$confirm("填写数据将不会保存，您确定退出救助申请操作吗?")
        .then(() => {
          this.visible = false;
        })
        .catch(() => {});
    },
    // 最大最小金额提示
    showMessage(val, index) {
      if (val < this.eyesData[index].min) {
        this.$message.warning(`最小金额不能小于${this.eyesData[index].min}`);
        this.eyesData[index].eye_money = this.eyesData[index].min;
      }
      if (val > this.eyesData[index].max) {
        this.$message.warning(`最大金额不能超过${this.eyesData[index].max}`);
        this.eyesData[index].eye_money = this.eyesData[index].max;
      }
    },

    //关闭操作
    closeBtn() {
      this.$confirm("此操作将会离开表单页面", "离开提示", {
        confirmButtonText: "我要离开",
        cancelButtonText: "继续填写",
        type: "warning"
      })
        .then(() => {
          this.visible = false;
        })
        .catch(() => {});
    },

    //提交申请
    submitForm() {
      this.applyForm.project_type = 2; //代表公益项目

      this.$refs["applyRef"].validate(valid => {
        if (valid) {
          if (this.eyesData && this.eyesData[0]) {
            this.applyForm.eye = this.eyesData;
          }

          if (
            !this.applyForm.apply_amount ||
            this.applyForm.apply_amount == 0
          ) {
            return this.$message.warning("请填写申请金额！");
          }

          let arr = [];
          if (this.defFiles && this.defFiles.length > 0) {
            for (const item of this.defFiles) {
              if (item.hasOwnProperty("response")) {
                arr.push(item.response.data.id);
              } else {
                arr.push(item.id);
              }
            }
            this.applyForm.poor_files = arr;
          } else {
            this.$message.warning("请上传贫困证件！");
            return;
          }
          let url;
          if (this.applyForm.id) {
            url = this.$db.config.updateProjectApplyForm;
          } else {
            url = this.$db.config.sumbitProjectApplyForm;
          }

          this.loading = true;
          this.$db.post(url, this.applyForm).then(res => {
            this.loading = false;
            if (res.code == 200) {
              this.visible = false;
              this.$message.success(res.msg);
              this.$emit("success");
            }
          });
        } else {
          return this.$message.warning("请填写完整表单信息！");
        }
      });
    },
    beforeUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    onSuccess(response, file, fileList) {
      //头像上传
      if (response.code == 200) {
        this.applyForm.header_pic = response.data.id;
        this.showHeadPic = true;
        this.uploadImgHeadPic = response.data.imgPath;
      }
    },

    addTableRow(index) {
      //添加一行table
      let len = this.eyesData.length;
      if (len > 0 && this.eyesData[len - 1].eye_money == 0) {
        return this.$message.warning("金额不能为0！");
      }

      let temp = {
        eye_type: {},
        eye_money: null
        // disabled: false
      };
      this.eyesData.push(temp);
    },
    handleDelete(index, row) {
      this.eyesData.splice(index, 1);
    },

    getCity(value, isEdit = false) {
      if (!isEdit) {
        this.applyForm.city_id = null;
        this.applyForm.county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 2, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.cityLists = resp.data;
          }
        });
    },
    getCounty(value, isEdit = false) {
      if (!isEdit) {
        this.applyForm.county_id = null;
      }
      this.$db
        .post(this.$db.config.getRegionUrl, { level: 3, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.countyLists = resp.data;
          }
        });
    },

    // 去掉字符串中所有空格(包括中间空格,需要设置第2个参数为:g)
    Trim(str, is_global) {
      var result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    // 读取身份证相关信息，并自动填充
    handleInfoReader() {
      // 渲染省市县、生日、性别、籍贯等信息
      let cardno = this.Trim(this.applyForm.user_cardno, "g");

      this.applyForm.user_cardno = cardno;

      // 出生年月
      let year1 = cardno.substring(6, 10);
      let month1 = cardno.substring(10, 12);
      let day1 = cardno.substring(12, 14);
      let birthday = year1 + "-" + month1 + "-" + day1;
      this.$set(this.applyForm, "birthday", birthday);

      // 性别
      let sex = cardno.substring(16, 17);
      let user_sex = Number(sex) % 2 == 0 ? 2 : 1;
      this.$set(this.applyForm, "user_sex", user_sex);
      var date = new Date();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      var age = date.getFullYear() - cardno.substring(6, 10) - 1;
      if (
        cardno.substring(10, 12) < month ||
        (cardno.substring(10, 12) == month && cardno.substring(12, 14) <= day)
      ) {
        age++;
      }

      this.$set(this.applyForm, "age", age);
    },
    getProjectList() {
      //获取可申请的简单众筹项目列表
      this.$db
        .post(this.$db.config.getApplyComprojectList, { project_type: 1 })
        .then(res => {
          if (res.code == 200) {
            this.projectList = res.data;
          }
        });
    },

    //根据项目id获取相关内容
    selProject(val) {
      this.applyForm.project_apply_id = val
      this.applyForm.project_id = this.projectList.find(
        item => item.project_apply_id == val
      ).id;
      if (val) {
        this.$db
          .post(this.$db.config.getUnitMoneyByProId, {
            project_apply_id: this.applyForm.project_apply_id,
            project_id: this.applyForm.project_id
          })
          .then(res => {
            //获取该项目相关金额
            if (res.code == 200) {
              this.otherMoney = res.data;
            }
          });

        this.$db
          .post(this.$db.config.getCfProApplyUserTypes, {
            project_type: 2,
            project_id: this.applyForm.project_id
          })
          .then(res => {
            //获取贫困类型
            if (res.code == 200) {
              this.$set(this, "userTypeList", res.data);
            }
          });
      }
    },

    //根据贫困类型获取眼疾种类
    selApplyType(val) {
      if (val) {
        let arr = [];
        for (const item of val) {
          if (this.userTypeList.find(res => res.apply_user_type == item)) {
            arr.push(
              this.userTypeList.find(res => res.apply_user_type == item)
            );
          }
        }
        this.eyeTypeList = arr;
      }
    },

    //选择眼疾信息中的申请人类别
    selUserType(val, index) {
      this.moneyList[index] = [];
      this.$db
        .post(this.$db.config.getEyeTypeByUserType, {
          project_type: 2,
          project_id: this.applyForm.project_id,
          apply_user_type: val
        })
        .then(res => {
          //获取贫困类型
          if (res && res.code == 200) {
            this.$set(this.moneyList, index, res.data);
          }
        });
    },

    //根据眼疾获取金额区间
    selEyeType(item, index) {
      this.eyesData[index].min = parseInt(item.funds_start);
      this.eyesData[index].max = parseInt(item.funds_end);
      this.eyesData[index].eye_diseases = parseInt(item.eye_diseases);
      this.eyesData[index].eys_esparation = parseInt(item.eys_esparation);
    },

    //获取医保类型
    getYbTypeList() {
      this.$db
        .post(this.$db.config.getDictParam, { pid: 200402, table: "pub_dict" })
        .then(res => {
          if (res.code == 200) {
            this.ybTypeList = res.data;
          }
        });
    },

    //清空编辑的眼别内容 重新选择眼别 解决编辑选中问题
    clearEye() {
      this.eyeEditInfo = [];
      this.applyForm.eye = [];
      delete this.applyForm.eye_text;
      this.selApplyType(this.applyForm.apply_type);
    },

    //获取详情
    getApplyInfo() {
      this.$db
        .post(this.$db.config.getCfProApplyEditInfo, { id: this.id })
        .then(res => {
          if (res.code == 200) {
            this.selProject(res.data.project_apply_id);
            this.eyeEditInfo = res.data.eye_text;
            this.applyForm = res.data;
            if (res.data.apply_type && res.data.apply_type[0]) {
              this.applyForm.apply_type = res.data.apply_type.map(Number);
              // this.selApplyType(this.applyForm.apply_type);
            }
            if (res.data.header_pic_url != "" && res.data.header_pic_url) {
              this.uploadImgHeadPic = res.data.header_pic_url;
              this.showHeadPic = true;
            }
            // 省市县
            if (res.data.province_id) {
              this.applyForm.province_id = res.data.province_id;
              this.getCity(this.applyForm.province_id, true);
            }

            if (res.data.city_id) {
              this.applyForm.city_id = res.data.city_id;
              this.getCounty(this.applyForm.city_id, true);
            }

            if (res.data.county_id) {
              this.applyForm.county_id = res.data.county_id;
            }

            if (res.data.poor_files && res.data.poor_files_path.length > 0) {
              this.defFiles = res.data.poor_files_path;
            }
          }
        });
    }
  },
  mounted() {
    this.visible = this.value;
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;

    this.$db.post(this.$db.config.getRegionUrl, { level: 1 }).then(resp => {
      if (resp && resp.code == 200) {
        this.provinceLists = resp.data;
      }
    });

    this.getYbTypeList();
    this.getProjectList();

    if (this.id > 0) {
      // 编辑操作
      this.getApplyInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .drawer-class {
  overflow: auto;
}
.demo-drawer-footer {
  width: 85%;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.avatar-uploader /deep/ .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  border: none;
  overflow: hidden;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/apply/info.vue